<template>
  <div class="passenger">
    <label :for="uniqueId">Child {{ uuid }}</label>
    <input
      :id="uniqueId"
      :min="0"
      :max="minAdultAge - 1"
      v-model.number="age"
      @blur="$v.age.$touch()"
      @input="update"
      pattern="\d+"
      type="number"
      placeholder="Child’s age"
    />
    <ValidationMessage v-if="!$v.age.required">
      Please enter your child's age.
    </ValidationMessage>
    <ValidationMessage v-if="!$v.age.maxValue">
      Child must be younger than {{ minAdultAge }} years of age.
    </ValidationMessage>
    <ValidationMessage v-if="!$v.age.minValue">
      If you're expecting, please contact customer services should your new born
      arrive before you depart.
    </ValidationMessage>
  </div>
</template>

<script>
import Vue from "vue";
import Vuelidate from "vuelidate";
import ValidationMessage from "../ValidationMessage";
Vue.use(Vuelidate);

import {
  required,
  numeric,
  minValue,
  maxValue
} from "vuelidate/lib/validators";

let uuid = 1;
const adultValidation = (input, age) => {
  return input === null || input >= age;
};

export default {
  name: "Passenger",
  components: {
    ValidationMessage
  },
  props: {
    grouping: {
      type: String,
      default: "children",
      validator(value) {
        return ["adults", "children"].includes(value);
      }
    },
    minAdultAge: {
      type: Number,
      default: 17
    },
    value: {
      type: Object,
      default: () => ({
        age: null
      })
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(value) {
        this.age = value.age;
      }
    },
    age: {
      handler() {
        this.$v.age.$touch();
      }
    }
  },
  beforeCreate() {
    this.uuid = uuid.toString();
    uuid += 1;
  },
  destroyed() {
    uuid -= 1;
  },
  data() {
    return {
      age: null
    };
  },
  computed: {
    uniqueId() {
      return `tgmag-passenger-${this.uuid}`;
    }
  },
  methods: {
    update() {
      this.$emit("input", { age: this.age });
    }
  },
  validations() {
    if (this.grouping === "children") {
      return {
        age: {
          required,
          numeric,
          minValue: minValue(0),
          maxValue: maxValue(this.minAdultAge - 1)
        }
      };
    } else {
      return {
        age: {
          isAdult: adultValidation(this.minAdultAge)
        }
      };
    }
  }
};
</script>
<style scoped>
.passenger {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 4px 0;
}

.passenger label {
  flex: 2 1 auto;
  background-color: white;
  font-weight: 600;
  font-size: 14px;
  color: #032f61;
}

.passenger input {
  padding: 12px 18px;
  flex-grow: 1;
  max-width: 100%;
  font-size: 14px;
  font-weight: 400;
  border: 1px solid #b8b8b8;
  border-radius: 4px;
  height: 48px;
  box-sizing: border-box;
}

.tgmag-passenger__validation {
  min-width: 100%;
  font-size: 12px;
  margin: 12px 0;
  color: var(--error);
}
</style>
